import styled from '@emotion/styled'

import { Modal } from '@onl-web/shared/components'

import { COLORS } from '@/styles/colors'

export type AlertPrimaryVariant = 'default' | 'danger'

const PRIMARY_BG_BY_VARIANT: Record<AlertPrimaryVariant, string> = {
  default: COLORS.bgInverse,
  danger: COLORS.bgNegative,
}

export const AlertBackdrop = styled(Modal.Backdrop)`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1000;
`

export const AlertContent = styled(Modal.Content)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
  padding: 32px 20px 20px;
  background-color: ${COLORS.bgWhite};
  border-radius: 16px;
  box-shadow:
    0 4px 4px rgba(0, 0, 0, 0.16),
    0 0 1px rgba(0, 0, 0, 0.12);
`

export const AlertTextArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
  text-align: center;
`

export const AlertTitle = styled(Modal.Title)`
  margin: 0;
  width: 100%;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: -0.3px;
  color: ${COLORS.textPrimary};
`

export const AlertDescription = styled(Modal.Description)`
  margin: 0;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textSecondary};
`

export const AlertActions = styled(Modal.Actions)`
  display: flex;
  gap: 12px;
  width: 100%;
`

export const AlertSecondaryButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 12px;
  border: none;
  border-radius: 12px;
  background-color: ${COLORS.bgDisabled};
  color: ${COLORS.textSecondary};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.08px;
  cursor: pointer;
`

export const AlertPrimaryButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: AlertPrimaryVariant }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 12px;
  border: none;
  border-radius: 12px;
  background-color: ${({ variant }) => PRIMARY_BG_BY_VARIANT[variant]};
  color: ${COLORS.textInverse};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.08px;
  cursor: pointer;
`
